import { render, staticRenderFns } from "./SideMenuAvatar.vue?vue&type=template&id=587c9c18&scoped=true"
import script from "./SideMenuAvatar.vue?vue&type=script&lang=js"
export * from "./SideMenuAvatar.vue?vue&type=script&lang=js"
import style0 from "./SideMenuAvatar.vue?vue&type=style&index=0&id=587c9c18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587c9c18",
  null
  
)

export default component.exports